<div id="view_request_dialog">
    <div class="position_relative" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100 dialog_header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                <div>{{data.title}}</div>
                <div class="header_room">Task Reference No. {{taskRefNumber}}</div>
            </div>
            <div class="filter_section dropdownCustom" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <app-select class="filter_3" label="Status" [noEmptyValue]="true" [value]="requestStatus"
                    (selectionChange)="requestStatus = $event" [selectOptions]="selectOptions"></app-select>
            </div>
        </div>
        <div class="width_100 dialog_body" fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start center">
            <div class="room_number">Room No. {{roomNumber}}</div>
            <div *ngIf="requestTotal > 0" class="width_100 dialog_section" fxLayout="column"
                fxLayoutAlign="start center">
                <div *ngFor="let request of requestData" class="width_100" fxLayoutGap="20px" fxLayout="column"
                    fxLayoutAlign="start center">
                    <div *ngIf="request.houseKeepingRequest && request.houseKeepingRequest.length > 0"
                        class="width_100 section_header" fxLayoutGap="20px" fxLayout="row"
                        fxLayoutAlign="space-between center">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="start center">
                            <!-- <mat-icon [svgIcon]="'amenities'"></mat-icon> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" style="margin-right: 8px;" viewBox="0 0 13 14.451">
                                <path id="bottle-tonic-outline"
                                    d="M18.208,11.434v7.65h-13v-7.65A4.461,4.461,0,0,1,9.85,7.184v-1.7H8.922v-.85h5.571v.85h-.929v1.7a4.461,4.461,0,0,1,4.642,4.25m-1.857,0a2.683,2.683,0,0,0-2.786-2.55H9.85a2.683,2.683,0,0,0-2.786,2.55v5.95H16.35Z"
                                    transform="translate(-5.208 -4.633)" fill="#868e96" />
                            </svg>

                            <div class="section_header_label">{{request.name}}</div>
                        </div>
                        <div class="section_quantity margin_right_15_px">Qty.</div>
                    </div>
                    <div *ngFor="let requestItems of request.houseKeepingRequest" class="width_100 margin_bottom_20"
                        fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start center">
                        <div class="width_100 section_body" fxLayoutGap="20px" fxLayout="row"
                            fxLayoutAlign="space-between center">
                            <div class="section_body_label">{{requestItems.requestItem}}</div>
                            <div class="section_body_quantity margin_right_15_px">
                                x{{requestItems.requestQuantity}}</div>
                        </div>
                    </div>
                </div>
                <div class="width_100 section_body extra_border" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="section_body_label">Total items</div>
                    <div class="section_body_quantity margin_right_15_px">{{requestTotal}}</div>
                </div>
            </div>
            <div *ngIf="requestNote" class="width_100 dialog_section" fxLayoutGap="20px" fxLayout="column"
                fxLayoutAlign="start center">
                <div class="width_100 section_header" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="width_100" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="start center">
                        <div class="section_header_label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin-right: 8px;"
                                viewBox="0 0 12 12">
                                <path id="tag-outline"
                                    d="M14.646,8.748l-5.4-5.4A1.2,1.2,0,0,0,8.4,3H4.2A1.2,1.2,0,0,0,3,4.2V8.4a1.2,1.2,0,0,0,.354.852l5.4,5.4a1.2,1.2,0,0,0,1.692-.006l4.2-4.2a1.2,1.2,0,0,0,0-1.7M9.6,13.8,4.2,8.4V4.2H8.4l5.4,5.4M5.7,4.8a.9.9,0,1,1-.9.9A.9.9,0,0,1,5.7,4.8Z"
                                    transform="translate(-3 -3)" fill="gray" />
                            </svg>NOTE:
                        </div>
                    </div>
                </div>
                <div class="width_100 section_body" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="section_body_label">{{requestNote}}</div>
                </div>
            </div>
        </div>
        <div class="width_100 dialog_footer" fxLayout="row" fxLayoutAlign="center center">
            <div [mat-dialog-close]="requestStatus" fxLayout="row" class="request_status_new"
                fxLayoutAlign="center center">
                <div>Close</div>
            </div>
        </div>
    </div>
</div>